import React, { Component } from "react";
import { getHistoryBooks } from "../actions/bookAction";
import { connect } from "react-redux";

import "./homepage.css";
import { Container } from "@material-ui/core";
import { Grid, Image } from "semantic-ui-react";
import Paper from "@material-ui/core/Paper";
import SearchTool from "./searchTool";
export class HistoryBooks extends Component {
  constructor() {
    super();
    this.state = { books: [] };
  }
  componentDidMount() {
    this.props.getHistoryBooks();
  }

  render() {
    const { books } = this.props.books;
    var bookList;
    var bookAddress;
    if (books) {
      if (books.results) {
        if (books.results) {
          books.results.map((data, index) =>
            data.formats["text/html; charset=utf-8"]
              ? (bookAddress = data.formats["text/html; charset=utf-8"])
              : ""
          );
        }
        bookList = (
          <Grid columns={6}>
            <Grid.Row stretched>
              {books.results.map((data, index) => (
                <React.Fragment key={index}>
                  <Grid.Column only="computer">
                    <Paper>
                      {data.formats["image/jpeg"] ? (
                        <Image
                          src={data.formats["image/jpeg"]}
                          style={{ height: "200px", width: "250px" }}
                        />
                      ) : (
                        "NO"
                      )}
                      {
                        <a href={bookAddress}>
                          <h5>{data.title}</h5>
                        </a>
                      }
                    </Paper>
                    <br />
                    <br />
                    <br />
                    <br />
                  </Grid.Column>

                  <Grid.Column only="mobile" mobile={5}>
                    <Paper>
                      {data.formats["image/jpeg"] ? (
                        <Image
                          src={data.formats["image/jpeg"]}
                          style={{ height: "100px", width: "100px" }}
                        />
                      ) : (
                        "NO"
                      )}
                      {
                        <a href={bookAddress}>
                          <h5>{data.title}</h5>
                        </a>
                      }
                    </Paper>
                    <br />
                    <br />
                    <br />
                  </Grid.Column>
                </React.Fragment>
              ))}
              ;
            </Grid.Row>
          </Grid>
        );
      }
    }

    return (
      <Container>
        <SearchTool />
        <h1>History</h1>

        {bookList}
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  books: state.books
});

export default connect(
  mapStateToProps,
  { getHistoryBooks }
)(HistoryBooks);
